export default __webpack_public_path__ + "media/styles/images/ml-grey-23693ffe4543205588ac3a1d5d01e119.svg";